export enum ReportStatusEnum {
    Pending = 'PENDING',
    Ready = 'READY',
    Error= 'ERROR',
  }
